import { render, staticRenderFns } from "./freezing-file.vue?vue&type=template&id=70d1dfab"
import script from "./freezing-file.vue?vue&type=script&lang=js"
export * from "./freezing-file.vue?vue&type=script&lang=js"
import style0 from "./freezing-file.vue?vue&type=style&index=0&id=70d1dfab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports